/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
  //Sticky header
  $(window).on('scroll', function (e) {
    if ($(this).scrollTop() >= 10) {
      $(".site-header").addClass("sticky");
    } else {
      $(".site-header").removeClass("sticky");
    }
    if ($(this).scrollTop() >= 500) {
      $(".fsticky").addClass("sticky");
    } else {
      $(".fsticky").removeClass("sticky");
    }
    if ($(this).scrollTop() >= 800) {
      $(".go-up").addClass("active");
    } else {
      $(".go-up").removeClass("active");
    }
  });
  $(document).on('click', '.search-toggle', function (e) {
    $('html').toggleClass('search-on');
    $(this).find('svg').toggleClass('d-none');
    $('.mm-menu').removeClass('active');
    $('.mm').removeClass('active');
    $('body').removeClass('nav-open');
  });







  //Trending slider
  if ($('.tg-grids').length) {
    $('.tg-grids').slick({
      dots: false,
      arrows: false,
      slidesToShow: 5,
      autoplay: false,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: true
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          autoplay: true,
          autoplaySpeed: 2000,
        }
      }, {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 2000,
        }
      }]
    });
  }
  //Collections Slider
  if ($('.cf-grids').length) {
    $('.cf-grids').slick({
      dots: false,
      arrows: true,
      slidesToShow: 3,
      infinite: false,
      prevArrow: "<button type='button' class='slick-prev pull-left'><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12.667 8L3.33366 8' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/><path d='M8 12.6665L3.33333 7.99984L8 3.33317' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.33301 8H12.6663' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/><path d='M8 3.3335L12.6667 8.00016L8 12.6668' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          infinite: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }, {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        }
      }]
    });
  }
  //Collections Slider (style two)
  if ($('.cf-gridstwo').length) {
    $('.cf-gridstwo').slick({
      dots: false,
      arrows: true,
      slidesToShow: 4,
      prevArrow: "<button type='button' class='slick-prev pull-left'><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12.667 8L3.33366 8' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/><path d='M8 12.6665L3.33333 7.99984L8 3.33317' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.33301 8H12.6663' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/><path d='M8 3.3335L12.6667 8.00016L8 12.6668' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: true
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }, {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        }
      }]
    });
  }
  //Festival Gallery Slider
  if ($('.fg-gallery').length) {
    $('.fg-gallery').slick({
      dots: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      initialSlide: 1,
//       centerMode: true,
// // centerPadding: '20%',
      // centerMode: true,
      // focusOnSelect: true,
      // prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12.667 8L3.33366 8' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/><path d='M8 12.6665L3.33333 7.99984L8 3.33317' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      // nextArrow:"<button type='button' class='slick-next pull-right'><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.33301 8H12.6663' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/><path d='M8 3.3335L12.6667 8.00016L8 12.6668' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      prevArrow: $('.prev-slide'),
      nextArrow: $('.next-slide'),
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          // infinite: true
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          //infinite: true
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          // centerMode: true,
          // focusOnSelect: true,
        }
      }, {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        }
      }]
    });
  }
  //Festivals past
  if ($('.fp-grids').length) {
    $('.fp-grids').slick({
      dots: false,
      arrows: true,
      slidesToShow: 4,
      rows: 0,
      prevArrow: "<button type='button' class='slick-prev pull-left'><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12.667 8L3.33366 8' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/><path d='M8 12.6665L3.33333 7.99984L8 3.33317' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.33301 8H12.6663' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/><path d='M8 3.3335L12.6667 8.00016L8 12.6668' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          infinite: true
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }, {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        }
      }]
    });
  }




  //Past GAlerry
  function youtube_parser(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match && match[7].length == 11) ? match[7] : false;
  }

  $('.gallery_video').each(function (item) {
    var vSrc = youtube_parser($(this).attr('href'));

    var vImg = 'https://img.youtube.com/vi/' + vSrc + '/0.jpg';
    $(this).find('.fp-grids-box-thumb-img').attr("src", vImg);
  });

  if ($('.video-popup').length) {
      var vSrc = youtube_parser($('.video-popup').attr('href'));
      var vImg = 'https://img.youtube.com/vi/' + vSrc + '/0.jpg';
      $('.video-popup-img').attr("src", vImg);
  }

  if ($('.fp-grids').length) {
    $('.fp-grids').magnificPopup({
      delegate: 'a', // child items selector, by clicking on it popup will open
      type: 'image',
      gallery: {
        enabled: true,
        preload: [0, 1]
        //navigateByImgClick: true,
        // arrowMarkup: "<button title='%title%' type='button' class='mfp-arrow mfp-arrow-%dir%'><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12.667 8L3.33366 8' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/><path d='M8 12.6665L3.33333 7.99984L8 3.33317' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      },
      callbacks: {
        elementParse: function (item) {
          //console.log(item.el[0].className);
          if (item.el.hasClass('gallery_video')) {
            item.type = 'iframe',
              item.iframe = {
                patterns: {
                  youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }

                    src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
                  },
                  vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                  },
                  gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                  }
                }
              }
          } else {
            item.type = 'image',
              item.image = {
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
              }
          }
        }
      }
      // other options
    });
  }

  //Gallery
  if ($('.fg-gallery').length) {
    $('.fg-gallery').magnificPopup({
      delegate: 'a', // child items selector, by clicking on it popup will open
      type: 'image',
      gallery: {
        enabled: true,
        preload: [0, 1]
        //navigateByImgClick: true,
        // arrowMarkup: "<button title='%title%' type='button' class='mfp-arrow mfp-arrow-%dir%'><svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12.667 8L3.33366 8' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/><path d='M8 12.6665L3.33333 7.99984L8 3.33317' stroke='#151617' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      },
      callbacks: {
        elementParse: function (item) {
          //console.log(item.el[0].className);
          if (item.el.hasClass('gallery_video')) {
            item.type = 'iframe',
              item.iframe = {
                patterns: {
                  youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }

                    src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
                  },
                  vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                  },
                  gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                  }
                }
              }
          } else {
            item.type = 'image',
              item.image = {
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
              }
          }
        }
      }
      // other options
    });
  }

  //Load more
  $(document).on('click', '.loadmore', function (e) {
    e.preventDefault();
    var $el = $(this),
      $tgt = $el.data('target'),
      link = $el.attr('href');
    if ($el.attr('disabled'))
      return;
    $el.addClass('loading').attr('disabled', true);
    $el.find('span').html('Loading...')
    $("<div>").load(link + $tgt, function () {
      $($tgt).append($(this).find($tgt).html());
      $el.parents('.load-more').removeAttr('disabled').remove();
    });
  });
  $(window).on("scroll", function () {
    if ($('.load-more').length) {
      var TopPos = $('.load-more').offset().top;
      var ST = $(this).scrollTop();
      var FH = $(this).outerHeight();
      if (ST + FH >= TopPos - 300) {
        $('.loadmore').trigger('click');
      }
    }
  });

  //Courses Pop

  if ($('.cl').length) {
    $('.cl').magnificPopup({
      delegate: '.cl-box', // child items selector, by clicking on it popup will open
      type: 'iframe',
      // gallery:{
      //   enabled:true,
      //   preload: [0,1]
      // },
    });
  }

  //Artist
  if ($('.fa-artist').length) {
    $('.fa-artist').magnificPopup({
      delegate: 'a.fa-artist-box', // child items selector, by clicking on it popup will open
      type: 'image',
      gallery:{
        enabled:true,
        preload: [0,1]
      },
    });
  }
  //Filter
  $(document).on('change', '.filter-list-item input, .af-filters-search input', function (e) {
    e.preventDefault();
    $('#filter-form').submit();
    $(this).parents('.filter-list-item').find('.dropdown-toggle .sort-val strong').text($(this).next().text());
    if ($(this).is(':radio')) {
      $(this).parents('.filter-list-item').find('li').removeClass('selected');
      $(this).parents('li').addClass('selected');
    } else {
      if ($(this).parents('li').hasClass('selected')) {
        $(this).parents('li').removeClass('selected');
      } else {
        $(this).parents('li').addClass('selected');
      }
    }

  });
  // $('.af-filters-search input[type=search]').on('search', function () {
  //   $('#filter-form').submit();
  // });
  $(document).on('submit', '#filter-form', function (e) {
    e.preventDefault();
    $('body').addClass('loading');
    var params = $(this).serialize(), action = $(this).attr('action'), url = action + '?' + params;
    // $("<div>").load(url + " #connections", function () {
    //   $("#connections").html($(this).find("#connections").html());
    // });
    $("<div>").load(url + " #search-results", function () {
      $("#search-results").html($(this).find("#search-results").html());
      //$el.parents('.load-more').removeAttr('disabled').remove();
      $('body').removeClass('loading');
      if (history.pushState) {
        history.pushState(null, null, url);
      };
    });
  });
  //Sub menu
  // $(document).on('click', '.em-menu a', function(e){
  //   e.preventDefault();
  //   //$(this).closest('li').addClass('active');

  //   //$('.em').toggleClass('active');
  //   if($('.em').hasClass('active') || $('.em-menu').hasClass('active')){
  //     $(this).parent().removeClass('active');
  //     $('.em').removeClass('active');
  //   } else {
  //     $(this).parent().addClass('active');
  //     $('.em').addClass('active');
  //   }



  // });
  // $(document).mouseup(function(e) {
  //   var container = $(".em");

  //   // if the target of the click isn't the container nor a descendant of the container
  //   if (!container.is(e.target) && container.has(e.target).length === 0) 
  //   {
  //       container.removeClass('active');
  //       if($('.em-menu').hasClass('active')){
  //         setTimeout(function() {
  //           $('.em-menu').removeClass('active');
  //         }, 100);
  //       } else {
  //        return;
  //       }
  //   }
  // });

  // $('body').on('click', '.em-menu a', function (e) {
  //   e.preventDefault();
  //   $(this).closest('li').toggleClass('active');
  //   $('.em').toggleClass('active');
  // });

  // $('body').on('click', '.fm-menu a', function (e) {
  //   e.preventDefault();
  //   $(this).closest('li').toggleClass('active');
  //   $('.fm').toggleClass('active');
  // });

  // $('.em-menu').attr('aria-haspopup', 'true');

  $('body').on('mouseover focus', '.em-menu a', function (e) {
    $(this).closest('li').addClass('active');
    $('.site-header-in-right-nav .menu-item').removeClass('active');
    $('.em').addClass('active');
   // $('.fm').removeClass('active');
    $('.fm, .am').removeClass('active');
  });
  $('body').on('mouseover focus', '.fm-menu a', function (e) {
    $(this).closest('li').addClass('active');
    $('.site-header-in-right-nav .menu-item').removeClass('active');
    $('.fm').addClass('active');
    //$('.em').removeClass('active');
    $('.em, .am').removeClass('active');
  });
  $('body').on('mouseover focus', '.am-menu a', function (e) {
    $(this).closest('li').addClass('active');
    $('.site-header-in-right-nav .menu-item').removeClass('active');
    $('.am').addClass('active');
    $('.em, .fm').removeClass('active');
  });
  $('body').on('mouseleave', '.em, .fm, .am', function (e) {
    enterMenu = false;
    $(this).closest('li').removeClass('active');
    $('.em').removeClass('active');
    $('.fm').removeClass('active');
    $('.am').removeClass('active');
  });
  var enterMenu = false;
  $('body').on('mouseenter ', '.em, .fm, .am', function (e) {
    enterMenu = true;
  });

  $('body').on('mouseleave focusout', '.fm-menu', function (e) {
    setTimeout(function () {
      if (!enterMenu) {
        $('.em').removeClass('active');
        $('.fm').removeClass('active');
        $('.am').removeClass('active');
      }
    }, 200);
  });

  $('body').on('mouseleave focusout', '.em-menu', function (e) {
    setTimeout(function () {
      if (!enterMenu) {
        $('.em').removeClass('active');
        $('.fm').removeClass('active');
        $('.am').removeClass('active');
      }
    }, 200);
  });

$('body').on('mouseleave focusout', '.am-menu', function (e) {
    setTimeout(function () {
      if (!enterMenu) {
        $('.em').removeClass('active');
        $('.fm').removeClass('active');
        $('.am').removeClass('active');
      }
    }, 200);
  });

  $('body').on('click', '.mm-menu', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('.mm').toggleClass('active');
    $('body').toggleClass('nav-open');
    $('html').removeClass('search-on');
    $('.search-toggle').find('svg:last-child').addClass('d-none');
    $('.search-toggle').find('svg:first-child').removeClass('d-none');
  });

  var container = $(".em");
  var menuItem = $(".em-menu a");
  var container2 = $(".fm");
  var menuItem2 = $(".fm-menu a");
  var container3 = $(".am");
  var menuItem3 = $(".am-menu a")
  
  var container3 = $(".search-toggle");
  var menuItem3 = $(".site-header-in-right-search input");

  $(document).mouseup(function (e) {
    // if the target of the click isn't the container nor a descendant of the container
    if ($('.em-menu').hasClass('active')) {
      if (!container.is(e.target) && container.has(e.target).length === 0 && !menuItem.is(e.target)) {
        container.removeClass('active');
        $('.em-menu').removeClass('active');
      }
    }
    if ($('.fm-menu').hasClass('active')) {
      if (!container2.is(e.target) && container2.has(e.target).length === 0 && !menuItem2.is(e.target)) {
        container2.removeClass('active');
        $('.fm-menu').removeClass('active');
      }
    }
    if ($('.am-menu').hasClass('active')) {
      if (!container4.is(e.target) && container4.has(e.target).length === 0 && !menuItem4.is(e.target)) {
        container4.removeClass('active');
        $('.am-menu').removeClass('active');
      }
    }
    if ($('html').hasClass('search-on')) {
      if (!container3.is(e.target) && container3.has(e.target).length === 0 && !menuItem3.is(e.target)) {
        $('html').removeClass('search-on');
        //menuItem3.find('svg').removeClass('d-none');
        $('.search-toggle').find('svg:last-child').addClass('d-none');
        $('.search-toggle').find('svg:first-child').removeClass('d-none');
      }
    }
  });
  $('body').on('click', '.mm .sub-head.menu-item-has-children', function (e) {
    //e.preventDefault();
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(".sub-head.menu-item-has-children").removeClass("active");
      $(this).toggleClass('active');
    }
  });
  $('body').on('click', '.mm .sub-head-m.menu-item-has-children', function (e) {
    // e.preventDefault();
    if ($(this).hasClass('subactive')) {
      $(this).removeClass('subactive');
    } else {
      $(".sub-head-m.menu-item-has-children").removeClass("subactive");
      $(this).toggleClass('subactive');
    }
  });
  //Meet Category
  function getParameter(p) {
    var url = window.location.search.substring(1);
    var varUrl = url.split('&');
    for (var i = 0; i < varUrl.length; i++) {
      var parameter = varUrl[i].split('=');
      if (parameter[0] == p) {
        return parameter[1];
      }
    }
  }
  if ($('.page-template-page-meet').length ) {
    var search = getParameter('search');
    if ((search && search != null)) {
      console.log(search);
      $('#search-results').show();
      $('.af-filters-dropdown').show();
      $('.cf').hide();
    } else {
      $('.cf').show();
      $('.cf-grids').slick('refresh');
      $('#search-results').hide();
      $('.af-filters-dropdown').hide();
    };
  };
  $('.af-filters-search input[type=search]').on('search', function () {
    if (!$(this).val()) {
      $('#search-results').show();
      //$('.af-filters-dropdown').hide();
      $('.cf').show();
      $('.cf-grids').slick('refresh');
    } else {
      $('#search-results').show();
      //$('.af-filters-dropdown').show();
      $('.cf').hide();
    }

  });

  $(document).on('click', '.gform_delete_file', function (e) {
    e.preventDefault();
    var $input = $(this).parents('.gfield_repeater_cell').find('.gform_hidden').closest('input');
    $('.uploadingmessage').remove();
    $input.val("");
  });
  $(document).on('change', '.repeater-upload', function (e) {
    if (!$(this).val()) {
      return false;
    }
    var $input = $(this).parents('.ginput_container').find('.gform_hidden').closest('input');
    var $this = $(this);
    $(this).parent().addClass('uploading');
    var file_data = $(this).prop('files')[0];

    var form_data = new FormData();
    form_data.append('file', file_data);
    form_data.append('action', 'ffi_file_upload');
    $('.gform_button,.gform_previous_button,.gform_next_button').attr('disabled', 'disabled');
    $('.ffi-uploading').remove();
    $input.parents('.gfield_repeater_cell').append('<div class="ffi-uploading ff-msgajx"><div id="" class="ginput_preview"><strong>Uploading...</strong></div></div>');
    $.ajax({
      url: ajax_ffi.ajax_url,
      type: 'POST',
      contentType: false,
      processData: false,
      data: form_data,
      success: function (response) {
        $('.ffi-uploading').remove();
        $input.parents('.gfield_repeater_cell').find('.ffi-uploadingmessage').remove();
        $this.parent().removeClass('uploading');
        $this.parent().addClass('active');
        $('.gform_button,.gform_previous_button,.gform_next_button').removeAttr('disabled');
        if (response.status) {
          $input.val(response.ats);
          $input.parents('.gfield_repeater_cell').append('<div class="ffi-uploadingmessage ff-msgajx"><div id="" class="ginput_preview"><button class="gform_delete_file"><span class="dashicons dashicons-trash" aria-hidden="true"></span></button> <strong>' + file_data.name + '</strong></div></div>');
        } else {
          $input.parents('.gfield_repeater_cell').append('<div class="ffi-uploadingmessage ff-msgajx"><div id="" class="ginput_preview"><strong>' + response.error + '</strong></div></div>');
        }

      }
    });
  });

  //Fileupload
  $(document).on('change', ('.ginput_container_fileupload input', '.ginput_container_customupload input'), function (e) {
    $(this).parent().addClass('active');
    // $(this).addClass('active');
  });

  //Fileupload
  $(document).on('change', ('.ginput_container_fileupload input', '.ginput_container_customupload input'), function (e) {
    $(this).parent().addClass('active');
    // $(this).addClass('active');
  });


  //add autocomplete off
  $('.datepicker').attr('autocomplete', 'off');

  $('select').selectric({ arrowButtonMarkup: '<span class="drop-arrow"></span>', });
  jQuery(document).on('gform_post_render', function(event, form_id, current_page){
    $('select').selectric({ arrowButtonMarkup: '<span class="drop-arrow"></span>', });
  });


  $(document).on('click', '.add_repeater_item', function (e) {
    $('.datepicker').removeClass('initialized');
    window.gformInitDatepicker();
    //$(this).addClass('gform_hidden');
    // Git status
  });



  //add autocomplete off
  $('.datepicker').attr('autocomplete', 'off');

  gform.addFilter('gform_repeater_item_pre_add', function (clone, item) {
    // alert("asdasd");
    // do stuff
    clone.find('.ff-msgajx').remove();
    return clone;
  });
   
  gform.addFilter('gform_repeater_post_item_delete', function () {
    
   /*  console.log(container);
    container.find('.add_repeater_item:last').removeClass('gform_hidden');
    return clone; */

  });
  
  //Datepicker
  var dates = new Array();

  gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj, formId, fieldId) {

    if (formId == 1 && fieldId == 30) {
      optionsObj.minDate = 0;
      optionsObj.onSelect = function (dateText, inst) {
        ffiaddOrRemoveDate(dateText);
        $('#input_1_30').val(dates.join(','));
      };
      optionsObj.beforeShowDay = function (date) {
        var gotDate = $.inArray($.datepicker.formatDate($(this).datepicker('option', 'dateFormat'), date), dates);
        if (gotDate >= 0) {
          return [false, "ui-state-highlight", "Event Name"];
        }
        return [true, ""];
      };
    }
   
    return optionsObj;
   
  });


  function ffiaddDate(date) {
    if (jQuery.inArray(date, dates) < 0)
      dates.push(date);
  }

  function ffiremoveDate(index) {
    dates.splice(index, 1);
  }

  // Adds a date if we don't have it yet, else remove it
  function ffiaddOrRemoveDate(date) {
    var index = jQuery.inArray(date, dates);
    if (index >= 0)
      ffiremoveDate(index);
    else
      ffiaddDate(date);
  }

  // Takes a 1-digit number and inserts a zero before it
  function ffipadNumber(number) {
    var ret = new String(number);
    if (ret.length == 1)
      ret = "0" + ret;
    return ret;
  }

  function extendMagnificIframe(){
      
      var $start = 0;
      var $iframe = {
          markup: '<div class="mfp-iframe-scaler">' +
                  '<div id="iframeId" class="mfp-close"></div>' +
                  '<iframe class="mfp-iframe" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' +
                  '</div>' +
                  '<div class="mfp-bottom-bar">' +
                  '<div class="mfp-title"></div>' +
                  '</div>',
          patterns: {
                  youtube: {
                      index: 'youtube.com/', 
                      id: 'v=', 
                      src: '//www.youtube.com/embed/%id%?autoplay=1' 
                  }
               }
      };

      return $iframe;     

    }

    $('.video-popup').magnificPopup({
      type: 'iframe',
      iframe: extendMagnificIframe()
    });

    //Social Popup
    // Inline popups
    $('.fs-social').magnificPopup({
      delegate: '.fs-social-on',
      //removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
      midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
    });

    //Terms expand
    $(document).on('click', '.termsplus label', function (e) {
      $(this).toggleClass('active');
    });

    //Go to top
    var wrap = $('.go-up');

    wrap.on("scroll", function(e) {
      console.log('hekl')
      if (this.scrollTop > 147) {
        wrap.addClass("active");
      } else {
        wrap.removeClass("active");
      }
      
    });
    $(window).on('scroll', function (e) {
      if ($(this).scrollTop() >= 500) {
        $(".go-up").addClass("sticky");
      } else {
        $(".go-up").removeClass("sticky");
      }
    });

    //Connection Name sorting
    if ($('.af').length ) {
      var toggle = getParameter('orderby');
      $(document).on('change', '.drop-sort input', function (e) {
        if($('.af-filters-sort-item input').val() == 'ASC'){
          $('.af-filters-sort-item input').val('DESC');
        } else {
          $('.af-filters-sort-item input').val('ASC');
        }
     });
      
    }
});
